import React from 'react';
import styled from 'styled-components';
import { navy } from '@zocdoc/branding/colors';

import { Icon } from './_base';

const HamburgerSVG = styled(Icon).attrs({ viewBox: '0 0 52 40' })`
    width: 1.3em;
`;

const Hamburger = ({ color = navy, ...props }) => (
    <HamburgerSVG
        data-test="icon-hamburger"
        {...props}
    >
        <g>
            <rect
                fill={color}
                height="5.7"
                width="51.4"
                x="0.3"
            />
            <rect
                fill={color}
                height="5.7"
                width="51.4"
                x="0.3"
                y="17.2"
            />
            <rect
                fill={color}
                height="5.7"
                width="51.4"
                x="0.3"
                y="34.3"
            />
        </g>
    </HamburgerSVG>
);

export {
    Hamburger as default,
    Hamburger,
};
